module.exports = __webpack_public_path__ + "img/logo-facebook.bfa47fd4.svg";